export default __webpack_public_path__ + "static/media/ort02.ee63c0e9.jpg";